import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import { RESET_3D_TOUCH, SETUP_3D_TOUCH } from "./messageTypes";

const ADD_REFERRAL_ACTION_TYPE = "add-referral";
const ThreeDeeTouch = window.ThreeDeeTouch;

if (ThreeDeeTouch && ThreeDeeTouch.isAvailable) {
  ThreeDeeTouch.isAvailable(available => {
    if (available) {
      onMessageFromWebApp(RESET_3D_TOUCH, () => {
        ThreeDeeTouch.enableLinkPreview();
        ThreeDeeTouch.configureQuickActions([]);
      });

      onMessageFromWebApp(SETUP_3D_TOUCH, ({ isAdmin }) => {
        ThreeDeeTouch.enableLinkPreview();
        ThreeDeeTouch.configureQuickActions([
          {
            type: ADD_REFERRAL_ACTION_TYPE,
            title: isAdmin ? "Add a Referral" : "Send Referral",
            iconType: "Add"
          }
        ]);
        ThreeDeeTouch.onHomeIconPressed = payload => {
          if (payload.type == ADD_REFERRAL_ACTION_TYPE) {
            sendMessageToWebApp("ADD_REFERRAL");
          }
        };
      });
    }
  });
}
